<template>
  <power-bi code="eyJrIjoiZTAxMzFhZTYtYmMwOC00NjU1LTgxYWEtZjhjNzg4YzIwZDE1IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },

};
</script>
